import { render, staticRenderFns } from "./DashboardPerformanceRo.vue?vue&type=template&id=cfa825ba&"
import script from "./DashboardPerformanceRo.vue?vue&type=script&lang=js&"
export * from "./DashboardPerformanceRo.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPerformanceRo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports